// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Wsl9","content":"styles_content__1bKv9","checkbox":"styles_checkbox__QedxO","checkboxLabel":"styles_checkboxLabel__J7y4S"};